<template>
  <div>
    <v-app class="p-4">
      <div
        class="p-0 pt-5 mt-5 mb-3 text-right"
        style="border: none !important"
      >
        <div class="col-md-10 mx-auto py-0 my-0">
          <v-switch
            hide-details
            color="indigo darken-3"
            class="mr-5 text-right"
            v-model="autoChange"
            label="تغییر اتوماتیک (دسته آگهی، شهر و محله)"
          ></v-switch>
        </div>
        <categoryselector
          :key="autoChange"
          @category-schema="getSchema"
          @category-fields="getFields"
          ref="category"
          :multiAdsCat="true"
        >
        </categoryselector>

        <div class="px-3 py-0 my-0">
          <input-maker
            class="py-0 my-0"
            :param="newSchema.smart_payload['advertise']"
            v-if="autoChange === true"
            :ui_schema="this.ui_schema"
            :fields="this.fields"
            :auto_changes="autoChange"
          >
          </input-maker>
          <similar-ads
            ref="smarts"
            :key="autoChange"
            class="py-0 mb-5"
            :adv="isSmart"
            :cats="myCategory"
            :auto_changes="autoChange"
          ></similar-ads>

          <div class="col-md-10 mx-auto">
            <send-ads-own
              :category="myCategory"
              :city="schema.advertise.location.city"
              :neighborhood="schema.advertise.location.neighborhood"
              :all="autoChange"
            ></send-ads-own>
          </div>
        </div>
        <div
          class="col-md-10 px-3 mx-auto py-0 my-0"
          style="border-top: 1px #7e8299 dashed"
        >
          <v-switch
            v-model="isDay"
            label="براساس روزهای هفته"
            color="indigo darken-3"
            hide-details
            class="my-3"
          ></v-switch>
        </div>
        <div
          v-if="isDay == false"
          class="col-md-10 px-3 mx-auto d-flex py-1"
          v-for="(item, index) in count"
        >
          <multi-times :key="item" :ref="item"></multi-times>
          <v-btn
            class="mx-1 mr-2"
            icon
            color="success"
            outlined
            small
            @click="count.push(Math.random())"
          >
            <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
          </v-btn>
          <v-btn
            v-if="count.length > 1"
            class="mx-1"
            icon
            color="error"
            outlined
            small
            @click="removeDate(index)"
          >
            <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
          </v-btn>
        </div>

        <div v-if="isDay === true" class="col-md-10 px-3 mx-auto py-1">
          <timr-with-days ref="withDays"></timr-with-days>
        </div>

        <div class="row col-md-10 mx-auto px-0">
          <div class="col-md-4">
            <v-text-field
              ref="count"
              min="1"
              max="240"
              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max"
              type="number"
              outlined
              label="حذف خودکار پس از انتشار"
              dense
              clear-icon="mdi-close-circle-outline"
              @keypress="allowOnlyNumbers(newSchema['expire'])"
              placeholder="چندساعت پس از انتشار، آگهی حذف شود؟"
              hint="بازه زمانی حداقل 1 و حداکثر 240 ساعت است"
              append-inner-icon="fa fa-pencil-alt"
              v-model.number="newSchema.smart_payload['expired_at']"
            >
            </v-text-field>
          </div>
          <div class="col-md-4">
            <v-text-field
              min="1"
              max="10"
              :rules="[(v) => !!v || 'این فیلد الزامی است']"
              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
              type="number"
              outlined
              label="تعداد آگهی جدید"
              dense
              clearable
              clear-icon="mdi-close-circle-outline"
              append-inner-icon="fa fa-pencil-alt"
              v-model.number="newSchema['per']"
            >
            </v-text-field>
          </div>
          <div class="col-md-4">
            <v-text-field
              min="1"
              max="10"
              :rules="[(v) => !!v || 'این فیلد الزامی است']"
              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
              type="number"
              outlined
              label="تعداد آگهی های من"
              dense
              clearable
              clear-icon="mdi-close-circle-outline"
              append-inner-icon="fa fa-pencil-alt"
              v-model.number="newSchema['count']"
            >
            </v-text-field>
          </div>
        </div>

        <div class="col-md-10 mr-auto">
          <v-btn @click="sendSmartAds(0)" class="submit-btn float-left">
            <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
            ثبت آگهی
          </v-btn>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import sendAdsOwn from "@/view/pages/ads/sendAds/sendAdsOwn";
import { Bus } from "@/main";
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
  name: "Smart",
  components: {
    ButtonTempl,
    TimrWithDays,
    MultiTimes,
    SimilarAds,
    TitleRibbon,
    InputMaker,
    AdsSelector,
    Inputs,
    NumberSelector,
    Automatics,
    CitySelector,
    Categoryselector,
    sendAdsOwn,
  },
  props: {
    divar: {
      required: true,
    },
    own: {
      required: true,
    },
    ads: {
      required: true,
    },
    multi_time: {
      type: Boolean,
      default: false,
    },
    pageName: {
      type: String,
      default: "ارسال آگهی هوشمند",
    },
    cats: {
      default: "",
    },
  },
  data() {
    return {
      picker: "",
      count: [1],
      autoChange: false,
      requireAds: false,
      isSmart: true,
      schema: {
        advertise: {
          category: "",
          location: {
            city: "",
            neighborhood: "",
          },
          images: [],
          contact: {
            chat_enabled: false,
            hide_phone: false,
            phone: null,
          },
        },
        available_at: "",
        expire_at: "",
      },
      multiTimes: {},
      newSchema: {
        type: "advertise",
        kind: "default",
        search_payload: {},
        smart_payload: {},
      },
      myCategory: "",
      isDay: false,
      selected: [],
    };
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    removeDate(index) {
      this.count.splice(index, 1);
    },
    sendSmartAds(number = 0) {
      const keys = Object.keys(this.multiTimes);

      if (keys.length > 0)
        var param = {
          ...this.newSchema,
          start_at: this.multiTimes[keys[0]].started,
          expire_at: this.multiTimes[keys[0]].end,
        };
      if (!this.$refs.smarts.$refs.city.validate()) return;

      $.ajax({
        url: `${url}/smarts`,
        method: "POST",
        fn: this.sendSmartAds,
        params: [number],
        msg: number + 1 >= keys.length,

        redirect: { path: "/adsList/smartsList" },
        headers: {
          ACCEPT: "application/json",
          "Content-Type": "application/json",
          Authorization: Token,
        },
        data: JSON.stringify(keys.length > 0 ? param : this.newSchema),
      }).always((data) => {
        number++;
        if (number < keys.length) this.sendSmartAds(number);
      });
    },
    allowOnlyNumbers(value) {
      let allowedKeys = [8, 46, 38, 40, 37, 39];
      const keypressed = value.which || value.keyCode;
      if (/[^0-9\s]+/.test(value.key)) {
        if (allowedKeys.every((e) => e !== keypressed)) {
          value.preventDefault();
        }
      } else return true;
    },
  },
  watch: {
    isDay: function (value) {
      if (value === true) {
        Bus.$on("getDayMode", (values) => {
          this.newSchema["days"] = values.day;
          this.newSchema["start_time"] = values.start;
          this.newSchema["end_time"] = values.end;
        });
      } else if (value === false) {
        Bus.$on("getTimeMode", (moment) => {
          this.newSchema["expire_at"] = moment.end;
          this.newSchema["start_at"] = moment.started;
          this.newSchema.smart_payload["repeat"] = moment.repeat;
        });
      }
    },
    autoChange(value) {
      if (value) {
        this.newSchema.smart_payload.advertise = {};
        this.newSchema.smart_payload.advertise.location = {};
      } else {
        delete this.newSchema.smart_payload.advertise;
        delete this.newSchema.smart_payload.advertise.location;
      }
    },
  },
  mounted() {
    Bus.$on("cityInfo", (value) => {
      if (this.autoChange) {
        this.newSchema.smart_payload["advertise"]["location"]["city"] =
          value.city;
        if (value.neighborhood === "") {
          delete this.newSchema.smart_payload["advertise"]["location"][
            "neighborhood"
          ];
        } else
          this.newSchema.smart_payload["advertise"]["location"][
            "neighborhood"
          ] = { vacancies: value.neighborhood };
      }
      this.schema.advertise.location.city = value.city;
      if (value.neighborhood === "")
        delete this.schema.advertise.location.neighborhood;
      else this.schema.advertise.location.neighborhood = value.neighborhood;
    });
    Bus.$on("category-current", (value) => {
      this.myCategory = value;
      if (this.autoChange) {
        this.newSchema.smart_payload["advertise"]["category"] = value;
      }
    });

    Bus.$on("getSimilarData", (value) => {
      this.newSchema.search_payload = value;
    });

    Bus.$on("dialogRange", (name, value = null) => {
      this.newSchema.search_payload[name] = value;
    });

    Bus.$on("selectedAds", (value) => {
      this.newSchema.smart_payload["advertises"] = value;
    });

    Bus.$on("getTimeMode", (value, key) => {
      this.multiTimes[key] = value;
    });
  },
};
</script>

<style scoped></style>
